import React from "react";
import { Phone, MessageCircle, FileText } from "lucide-react";
import { CONTACT } from "@/lib/contact";

export default function MobileStickyCTA() {
  return (
    <div
      data-testid="mobile-sticky-cta"
      className="md:hidden fixed bottom-0 left-0 right-0 z-50 grid grid-cols-3 bg-white border-t border-[#E5DDD0] shadow-[0_-6px_24px_-12px_rgba(15,23,42,0.25)]"
    >
      <a
        href={`tel:${CONTACT.primary.tel}`}
        data-testid="sticky-call"
        className="flex flex-col items-center justify-center py-3 text-[#2B2420] border-r border-[#E5DDD0] active:bg-[#F5EFE5]"
      >
        <Phone className="w-4 h-4 text-[#B8732C]" />
        <span className="text-[10px] font-bold uppercase tracking-wider mt-1">Call Ion</span>
      </a>
      <a
        href={CONTACT.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="sticky-whatsapp"
        className="flex flex-col items-center justify-center py-3 text-[#2B2420] border-r border-[#E5DDD0] active:bg-[#F5EFE5]"
      >
        <MessageCircle className="w-4 h-4 text-[#B8732C]" />
        <span className="text-[10px] font-bold uppercase tracking-wider mt-1">WhatsApp</span>
      </a>
      <a
        href="#quote"
        data-testid="sticky-quote"
        className="flex flex-col items-center justify-center py-3 text-white bg-[#B8732C] active:bg-[#9A5D1E]"
      >
        <FileText className="w-4 h-4" />
        <span className="text-[10px] font-bold uppercase tracking-wider mt-1">Free Quote</span>
      </a>
    </div>
  );
}
